// extracted by mini-css-extract-plugin
export default {"heroPage":"Hero_heroPage__gfi3G","heroLogo":"Hero_heroLogo__e-2c-","logoPulse":"Hero_logoPulse__iTmEe","logoFlicker":"Hero_logoFlicker__ac8li"};